import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import Links from 'utils/links';
import { rem } from 'design-system';
import Stars from './icons/Stars';
const QuoteTrustPilotLink = ({ rating: { reviews, stars, identifier }, }) => {
    const onPress = () => {
        const url = `https://trustpilot.com/review/${identifier}`;
        Links.openLink(url);
    };
    return (<View style={styles.container}>
      <Stars width={80} height={30} amount={stars}/>
      <TouchableOpacity onPress={onPress} style={styles.link}>
        <Text Text-14 Blue>
          {reviews} reviews on Trustpilot
        </Text>
      </TouchableOpacity>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    link: {
        marginLeft: rem(8),
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default QuoteTrustPilotLink;
